import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
    MAT_DIALOG_DATA,
    MatDialogModule,
    MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { InfoDialogComponent } from 'app/modules/landing/corporate/status-info/info-dialog/info-dialog.component';

@Component({
    selector: 'app-miti-popup',
    standalone: true,
    imports: [
        MatButtonModule,
        MatDialogModule,
        TranslateModule,
        MatIconModule,
        CommonModule,
    ],
    templateUrl: './miti-popup.component.html',
    styleUrl: './miti-popup.component.scss',
})
export class MitiPopupComponent implements OnInit {
    selectedLanguage: string = 'en';
    constructor(
        private dialogRef: MatDialogRef<InfoDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public miti: any
    ) {}

    ngOnInit(): void {
        this.selectedLanguage = localStorage.getItem('language');
    }

    closeDialog() {
        this.dialogRef.close();
    }
}
